document.addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper('.single_project_slider', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        watchOverflow: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        on: {
            init: function () {
                setSlideHeight(this);
                updateSlideCounter(this);
                initPopup();
            },
            slideChange: function () {
                updateSlideCounter(this);
            },
            resize: function () { 
                setSlideHeight(this);
            },            
        },
    });

    function setSlideHeight(swiper) {
        let maxHeight = 0;
        swiper.slides.forEach(function(slide) {
            maxHeight = Math.max(maxHeight, slide.offsetHeight);
        });
        swiper.slides.forEach(function(slide) {
            slide.style.height = maxHeight + 'px';
        });
    }    

    function updateSlideCounter(swiper) {
        var currentSlide = swiper.realIndex + 1;
        var totalSlides = swiper.slides.length; 
        document.querySelector('.swiper-pagination-custom').innerHTML = '<strong>'+currentSlide+'</strong>' + ' / ' + totalSlides;
    }
    function initPopup() {
        var popupOverlay = document.createElement('div');
        popupOverlay.className = 'popup-overlay';
        
        var closeButton = document.createElement('div');
        closeButton.className = 'close-icon';
        closeButton.innerHTML = '&times;'; 
        
        popupOverlay.appendChild(closeButton);
        document.body.appendChild(popupOverlay);
    
        document.querySelectorAll('.zoom-icon').forEach(function(icon) {
            icon.addEventListener('click', function() {
                console.log('Zoom icon clicked');
                var img = this.previousElementSibling; 
                if (img && img.tagName === 'IMG') { 
                    var popupImage = document.createElement('img');
                    popupImage.src = img.src;
                    popupImage.className = 'popup-image';
                    popupOverlay.innerHTML = ''; 
                    popupOverlay.appendChild(closeButton); 
                    popupOverlay.appendChild(popupImage);
                    popupOverlay.classList.add('active'); 
                } else {
                    console.error('Image not found or element is not an image');
                }
            });
        });
    
        popupOverlay.addEventListener('click', function(event) {
            if (event.target === this || event.target.classList.contains('close-icon')) {
                this.classList.remove('active'); 
            }
        });
    }

    if($('body').hasClass('page-template-template-members-materials')) {        
        var links = document.querySelectorAll('a[href^="#"]');
    

        links.forEach(function(link) {
            link.addEventListener('click', function(event) {
                event.preventDefault();
                var hash = this.getAttribute('href');

                var targetElement = document.querySelector(hash);
    
                if (targetElement) {

                    var offsetTop = targetElement.offsetTop - 100;

                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    });

                    history.pushState(null, null, hash);
                }
            });
        });            
    }    
});
